import { VueSlideToggle } from "vue-slide-toggle";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import { mapActions, mapGetters, mapMutations } from "vuex";
import editForm from "../edit-form-address/index.vue";

export default {
    name: "list-address",
    props: ["list"],
    data() {
        return {
            secondAddresses: [],
            payload: {
                active: 0,
                city: "",
                street: "",
                house: "",
                flat: "",
            },
            isEditSaved: false,
        };
    },
    components: {
        VueSlideToggle,
        editForm,
    },
    // validations() {
    //   return {
    //     payload: {
    //       city: {
    //         required,
    //         minLength: minLength(1),
    //         maxLength: maxLength(30),
    //       },
    //       street: {
    //         required,
    //         minLength: minLength(1),
    //         maxLength: maxLength(50),
    //       },
    //       house: {
    //         required,
    //         minLength: minLength(1),
    //         maxLength: maxLength(8),
    //       },
    //       flat: {
    //         required,
    //         minLength: minLength(1),
    //         maxLength: maxLength(8),
    //       },
    //       active: {}
    //     },
    //   }
    // },
    computed: {
        ...mapGetters({
            user: "profile/user",
        }),
    },
    watch: {
        user: function(newVal) {
            if (newVal) {
                this.secondAddresses = [];
                for (let i in this.user.addresses) {
                    if (this.user.addresses[i].active === 0) {
                        this.secondAddresses.push(this.user.addresses[i]);
                    }
                }
            }
        },
    },
    created() {
        for (let i in this.user.addresses) {
            if (this.user.addresses[i].active === 0) {
                this.secondAddresses.push(this.user.addresses[i]);
            }
        }
        // console.log(this.secondAddresses)
    },
    methods: {
        ...mapMutations({
            changePopupMainAddress: `profile/CHANGE_POPUP_MAIN_ADDRESS`,
        }),
        ...mapActions({
            fetchUserData: `profile/FETCH_USER_DATA`,
            deleteUserAddress: `profile/REMOVE_USER_ADDRESS`,
        }),
        removeAddress(item) {
            let obj = {};
            obj.id = item.id;
            // console.log(item.id);
            this.deleteUserAddress(obj)
                .then(() => {
                    this.$toasted.success(this.$t("youAddressRemove"));
                    this.fetchUserData();
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        console.log(error.response);
                    }
                });
        },
        closeEdit() {
            this.isEditSaved = false;
        },
    },
};
